// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDetails} from '../../shared/repositories';
import {readCustomerDetails} from '../../../customer/details/action-creators/details';
import {readLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';

export const updateProduct = pin =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDetails(pin);

            dispatch({
                data,
                type: actions.UPDATE_NEW_TRANSFER_PRODUCT_SUCCESS

            });

            if (data.customerSummary.id) {

                readCustomerDetails(data.customerSummary.id, data.customerPrivate)(dispatch);

            }

            if (data.otherUnitRequired === 'N') {

                readLatestPerUnitMeasurements(data.pin)(dispatch);

            }

        } catch (error) {

            dispatch({
                error,
                type: actions.UPDATE_DETAILS_ERROR
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetProductDetails = () => ({
    type: actions.RESET_PRODUCT_CUSTOMER_DETAILS
});



// WEBPACK FOOTER //
// ./src/product/new-transfer/action-creators/product.js